import forEach from 'lodash/forEach';

// Prepopulate gateways with orgId / agentId so we don't need to pass these params
// each time we make an API call.
const initializeGateways = (gateways, { orgId, userId }) => {
  forEach(gateways, gateway => {
    gateway.init({ agentId: userId, orgId });
  });
};

export default initializeGateways;
